import { useState } from "react";
import { Button } from "../../../../components/buttons/button";
import { NumberCard } from "../../../../components/cards/numberCard";
import { PopoverMenu } from "../../../../components/dropdown/popover";
import { CaretDown } from "../../../../components/icon/downcaret";
import { TableComponent } from "../../../../components/table";
import { BgWrapper } from "../../../../components/wrapper/bgWrapper";
import {
  useGetSalesAgentEarningsSummaryQuery,
  useGetSalesAgentMonthlyEarningsQuery,
} from "../../../../redux/features/admin/sales/sales.api";
import { SalesAgentMonthlyEarningsQuery } from "../../../../redux/features/admin/sales/sales.types";
import { formatToCurrency } from "../../../../utils/helpers";

export const CommissionsHistory = ({ agentId }: { agentId: string }) => {
  const [query, setQuery] = useState<SalesAgentMonthlyEarningsQuery>({
    id: agentId,
    year: new Date().getFullYear(),
    sortOrder: "asc",
  });

  const years = Array.from(
    { length: new Date().getFullYear() - 2025 + 1 },
    (_, i) => 2025 + i,
  );

  const { data: agentEarnings, isLoading: loadingAgentEarnings } =
    useGetSalesAgentEarningsSummaryQuery(
      {
        id: agentId,
      },
      { refetchOnMountOrArgChange: true },
    );

  const {
    data: agentMonthlyEarnings,
    isFetching: loadingAgentMonthlyEarnings,
  } = useGetSalesAgentMonthlyEarningsQuery(
    {
      ...query,
    },
    { refetchOnMountOrArgChange: true },
  );
  return (
    <>
      <BgWrapper className="grid grid-cols-1 gap-[10px] rounded-none md:grid-cols-2">
        <NumberCard
          value={agentEarnings?.data?.totalEarningsNGN ?? 0}
          text="Total Earnings"
          currency="NGN"
          isCurrency
          loading={loadingAgentEarnings}
          titleFirst
        />

        <NumberCard
          value={agentEarnings?.data?.totalTicketsSold ?? 0}
          text="Total Tickets Sold"
          isCurrency={false}
          loading={loadingAgentEarnings}
          titleFirst
        />
      </BgWrapper>

      <BgWrapper className="flex flex-col gap-3 rounded-t-none">
        <div className="flex w-full flex-col items-center justify-between gap-4 md:flex-row">
          <PopoverMenu
            menuItems={[...years].reverse().map((year) => {
              return {
                name: year,
                value: "",
                onClick: () => {
                  setQuery({
                    ...query,
                    year: year,
                  });
                },
              };
            })}
            menuClassName="!min-w-[230px] shadow-md !rounded-[8px]"
            menuItemsClassName="!font-bold !py-4"
            position="bottom start"
            closeOnClick
          >
            <Button
              type="button"
              text={`${query.year}`}
              className="!border-0 !p-0 !px-0 !py-0"
              variation="plain"
              extra={<CaretDown />}
            />
          </PopoverMenu>

          <div className="grid w-full grid-cols-2 items-center gap-3 md:flex md:w-fit md:flex-row">
            <Button
              type="button"
              onClick={() => {
                if (query.sortOrder === "asc") {
                  setQuery({ ...query, sortOrder: "desc" });
                } else {
                  setQuery({ ...query, sortOrder: "asc" });
                }
              }}
              text="Date Modified"
              className="!min-w-fit !rounded-2xl !p-3 !text-sm"
              icon={query.sortOrder === "asc" ? "order-asc" : "order-desc"}
              variation="grey"
            />

            <Button
              type="button"
              onClick={async () => {
                // await exportData({
                //   type: "users",
                //   fetchAll: true,
                //   sortOrder: query.sortOrder,
                //   search: query.search || undefined,
                //   searchTerm: query.search || undefined,
                // });
              }}
              text="Export"
              className="!min-w-fit !rounded-2xl !p-3 !text-sm"
              icon="export"
              variation="grey"
              //   loading={exportingData}
            />
          </div>
        </div>

        <TableComponent
          headers={[]}
          rows={
            agentMonthlyEarnings?.data?.map((earning, idx) => {
              return {
                id: `${idx}-${earning.month}-${query.year}`,
                items: [
                  <div
                    key={`${idx}-${earning.month}`}
                    className="flex flex-wrap items-center gap-2 text-grey-600"
                  >
                    <p className="flex-1">
                      <span className="font-bold text-grey-900">
                        {formatToCurrency(earning.totalEarnings.NGN, {
                          currency: "NGN",
                        })}{" "}
                        ∙{" "}
                        {formatToCurrency(earning.totalEarnings.CAD, {
                          currency: "CAD",
                        })}
                      </span>{" "}
                      ∙ {earning.totalTicketsSold || "No"} Tickets Sold
                    </p>

                    <p>
                      {earning.month}, {query.year}
                    </p>
                  </div>,
                ],
              };
            }) ?? []
          }
          emptyImage="/assets/images/percent-glass.png"
          emptyTitle="No Commissions Made"
          isTableEmpty={[0, undefined].includes(
            agentMonthlyEarnings?.data?.length,
          )}
          isPaginated={false}
          isLoading={loadingAgentMonthlyEarnings}
        />
      </BgWrapper>
    </>
  );
};
